import { AfterViewInit, Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SharedDataService } from '../all-services';
import { PS_Lib_Report_Et_Form_Result } from '../all-models';
import { Subject } from 'rxjs';


@Directive({
  selector: '[pafplaceholder]'
})
export class PafplaceholderDirective implements OnInit, OnChanges, AfterViewInit {
  @Input() pafplaceholder: string;
  labels: PS_Lib_Report_Et_Form_Result[] = [];
  private labelsReloadedSubject = new Subject<PS_Lib_Report_Et_Form_Result[]>();
  public labelsReloaded = this.labelsReloadedSubject.asObservable();
  
  constructor(
    private route: ActivatedRoute,
    public sharedDatasSvc: SharedDataService,
    private el: ElementRef){
  }
  ngAfterViewInit(): void {
    this.el.nativeElement.setAttribute("placeholder",this.getLabel());
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['pafplaceholder']) this.reloadLibs();
  }

  ngOnInit(): void {
    //this.reloadLibs();
    this.sharedDatasSvc.langChanged.subscribe((lngCod: string) => this.reloadLibs());
    setTimeout(():void=>{this.reloadLibs();});
  }

  reloadLibs(): void {
    let rescod: string = '';
    if (this.route.routeConfig) {
      rescod = this.route.routeConfig.path.split('/')[0];
    } else {
      rescod = "COMMON";
    }
    if (rescod) {
      this.sharedDatasSvc.getLabels(rescod)
        .subscribe((results: PS_Lib_Report_Et_Form_Result[]) => {
          this.labels = results;
          this.labelsReloadedSubject.next(results);
          this.el.nativeElement.setAttribute("placeholder",this.getLabel());
        });
    }
  }

  getLabel(lblCod?: string): string {
    let searchedLblCod: string = (lblCod || this.pafplaceholder || '');
    if (searchedLblCod == '') return '';
    const lblItem:PS_Lib_Report_Et_Form_Result=this.labels.find(i => i.LblCod == searchedLblCod);
    if (!lblItem) {
      return '???' + searchedLblCod + '???';
    } else {
      return lblItem.LblLabel.replace('\\n','<BR>');
    }
  }
}
